import request from '@/utils/request';

export const WF_CATEGORIES = 'WF_CATEGORIES';
export const WF_TEMPLATES = 'WF_TEMPLATES';
export const WF_TEMPLATE = 'WF_TEMPLATE';
export const WF_FLOWS = 'WF_FLOWS';
export const WF_FLOW = 'WF_FLOW';
export const WF_FLOW_HISTORY = 'WF_FLOW_HISTORY';

export const fetchWfCategories = () => async dispatch => {
  const response = await request({
    path: `/v1/workflow/wf_categories`
  });
  dispatch({
    payload: response,
    type: WF_CATEGORIES
  });
};

export const bulkUpdateWfCategories = body => async () =>
  await request({
    path: `/v1/workflow/wf_categories/bulk_update`,
    method: 'POST',
    body
  });

export const updateWfCategory = body => async () =>
  await request({
    path: `/v1/workflow/wf_categories`,
    method: 'PATCH',
    body
  });

export const deleteWfCategory = id => async () =>
  await request({
    path: `/v1/workflow/wf_categories/${id}`,
    method: 'DELETE'
  });

export const fetchWfTemplates = query => async dispatch => {
  const response = await request({
    path: `/v1/workflow/wf_templates`,
    query
  });
  dispatch({
    payload: response,
    type: WF_TEMPLATES
  });
};

export const createWfTemplate = body => async () =>
  await request({
    path: `/v1/workflow/wf_templates`,
    method: 'POST',
    body
  });

export const updateWfTemplate = body => async () =>
  await request({
    path: `/v1/workflow/wf_templates/${body.id}`,
    method: 'PATCH',
    body
  });

export const deleteWfTemplate = id => async () =>
  await request({
    path: `/v1/workflow/wf_templates/${id}`,
    method: 'DELETE'
  });

export const activateWfTemplate = id => async () =>
  await request({
    path: `/v1/workflow/wf_templates/${id}/activate`,
    method: 'PUT'
  });

export const fetchWfFlows = query => async dispatch => {
  const response = await request({
    path: `/v1/workflow/wf_flows`,
    query
  });
  dispatch({
    payload: response,
    type: WF_FLOWS
  });
};

export const clearWfFlow = () => async dispatch =>
  dispatch({
    payload: { data: {} },
    type: WF_FLOW
  });

export const copyWfFlow = data => async dispatch =>
  dispatch({
    payload: { data },
    type: WF_FLOW
  });

export const fetchWfFlow = id => async dispatch => {
  const response = await request({
    path: `/v1/workflow/wf_flows/${id}`
  });
  dispatch({
    payload: response,
    type: WF_FLOW
  });
};

export const fetchWfFlowHistory = (id, query) => async dispatch => {
  const response = await request({
    path: `/v1/workflow/wf_flows/${id}/history`,
    query
  });
  dispatch({
    payload: response,
    type: WF_FLOW_HISTORY
  });
};

export const createWfFlow = body => async () =>
  await request({
    path: `/v1/workflow/wf_flows`,
    method: 'POST',
    body
  });

export const updateWfFlow = body => async () =>
  await request({
    path: `/v1/workflow/wf_flows/${body.id}`,
    method: 'PATCH',
    body
  });

export const deleteWfFlow = id => async () =>
  await request({
    path: `/v1/workflow/wf_flows/${id}`,
    method: 'DELETE'
  });

export const activateWfFlow = body => async () =>
  await request({
    path: `/v1/workflow/wf_flows/${body.id}/activate`,
    method: 'PUT',
    body
  });
